import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { insightArticles } from "@/lib/insights";

const InsightsPage = () => (
  <main id="main-content" className="bg-[#f8f5ee] pt-24">
    <section className="relative overflow-hidden bg-[#0a0a0a] py-16 md:py-24">
      <div className="absolute inset-0 dot-pattern opacity-10 pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative">
        <div className="inline-block bg-[#ff6b35] text-[#0a0a0a] px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-5">
          Insights
        </div>
        <h1 className="font-display text-white text-[2.65rem] min-[380px]:text-5xl sm:text-7xl lg:text-8xl uppercase leading-[0.9] max-w-5xl">
          Guias para decidir melhor sobre tecnologia.
        </h1>
        <p className="mt-6 max-w-3xl text-white/75 text-lg sm:text-xl leading-snug">
          Conteúdos práticos sobre websites, SEO, automação, software e parceria tecnológica para PMEs em Portugal.
        </p>
      </div>
    </section>

    <section className="py-14 md:py-20 bg-[#ff6b35] noise">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        {insightArticles.map((article) => (
          <Link
            key={article.slug}
            to={article.path}
            className="brutal-card bg-white p-6 min-h-[330px] flex flex-col focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-white"
          >
            <p className="font-mono text-xs uppercase tracking-widest text-[#ff6b35] mb-4">
              {article.category} · {article.readingTime}
            </p>
            <h2 className="font-display text-[#0a0a0a] text-3xl sm:text-4xl uppercase leading-none">
              {article.h1}
            </h2>
            <p className="mt-5 text-[#0a0a0a]/75 leading-snug">
              {article.summary}
            </p>
            <span className="mt-auto pt-6 inline-flex items-center gap-2 font-mono uppercase text-xs tracking-widest text-[#0a0a0a]">
              Ler insight <ArrowRight size={16} className="shrink-0" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  </main>
);

export default InsightsPage;
